import { getLocalStorage } from '../../_common/client/local-storage';

// TODO check where cmp is coming from
export const BOUNCE_LAYER_LAST_OPENED_KEY = 'pdp_bounce-layer__last-opened-at';
export function shouldShowBounceLayer(event: MouseEvent): boolean {
    const shouldOpen =
        didMouseLeaveOnTopBorder(event) &&
        isCookieBannerPermissionGranted() &&
        !wasOpenedWithinLast30Minutes() &&
        isRecoAlternativeCinemaPresent();
    if (shouldOpen) {
        getLocalStorage().setItem(BOUNCE_LAYER_LAST_OPENED_KEY, Math.floor(Date.now() / 1000 / 60).toString());
    }
    return shouldOpen;
}

function didMouseLeaveOnTopBorder(event: MouseEvent) {
    return event.clientY <= 1;
}

function wasOpenedWithinLast30Minutes() {
    const lastOpened = getLocalStorage().getItem(BOUNCE_LAYER_LAST_OPENED_KEY);
    if (lastOpened === null) {
        return false;
    }
    const currentMinutes = Date.now() / 1000 / 60;
    return currentMinutes - +lastOpened < 30;
}

function isCookieBannerPermissionGranted() {
    return !!cmp?.getOttoOwnPurposesConsent?.();
}

function isRecoAlternativeCinemaPresent() {
    return document.querySelectorAll('.js_pdp_reco-alternative').length > 0;
}
